import { RESET_PASSWORD } from '../actionTypes'

export const resetPassword = (reset_code: string, new_password: string) => ({
  type: RESET_PASSWORD.name,
  api: {
    url: 'user/reset_password',
    data: { reset_code, new_password },
  },
})
